import { BaseService } from "./BaseService"
import getCookie from '../utils/getCookie'
import { buildCSEData, buildCSETravelerCompanions, CSECompanyData, CSEData, CSETraveller, CSETravellerCompanions } from "../classes/CSE"

export class CSEService extends BaseService {
    protected cseData: CSEData | null = null
    protected _initialized = false

    constructor(
        locale: string,
    ) {
        super(locale)
    }

    public get company(): string | undefined {
        if (!this._initialized) throw new Error("need to init first")
        return this.cseData?.company
    }

    public get companyData(): CSECompanyData | undefined {
        if (!this._initialized) throw new Error("need to init first")
        return this.cseData?.companyData
    }

    public get travellerCompanions(): CSETravellerCompanions | undefined {
        if (!this._initialized) throw new Error("need to init first")
        return this.cseData?.travelerCompanions
    }

    public get firstName(): string | undefined {
        if (!this._initialized) throw new Error("need to init first")
        return this.cseData?.companyData?.prenom
    }

    public get lastName(): string | undefined {
        if (!this._initialized) throw new Error("need to init first")
        return this.cseData?.companyData?.nom
    }
    public get email(): string | undefined {
        if (!this._initialized) throw new Error("need to init first")
        return this.cseData?.companyData?.mail
    }

    public get isCSE(): boolean {
        const company = getCookie("company")
        const isLocaleCSE = this.locale.indexOf("CSE") !== -1
        return Boolean(company && isLocaleCSE)
    }

    public get isCGOS() {
        const company = getCookie("company")
        if (!company) return false
        return ['CGOS', 'CGOSPM', 'CGOSAURA'].includes(company.toUpperCase())
    }

    public extractCSETravellerData(): CSETravellerCompanions {
        const travelerCompanionsJSON: string | undefined = getCookie("travelerCompanions")
        if (!travelerCompanionsJSON) throw new Error("if locale is CSE, cookie travelerCompanions must exist")
        const travelerCompanionsRaw: any = JSON.parse(travelerCompanionsJSON)
        const travelerCompanions: CSETravellerCompanions = buildCSETravelerCompanions(travelerCompanionsRaw)
        return travelerCompanions
    }

    public extractCSETravellerByIndex(index: number): CSETraveller {
        const travelerCompanions: CSETravellerCompanions = this.extractCSETravellerData()
        return travelerCompanions.travalers[index]
    }

    public init() {
        console.log("CSEService ~ init ~ init:")
        try {
            if (this._initialized) throw new Error("cannot init twice")
            if (!this.isCSE) throw new Error("cannot init CSEService when it is not CSE")

            const rawCompany: string | undefined = getCookie("company")
            const rawCompanyData: string | undefined = getCookie("companyData")
            const rawTravellerCompanions: string | undefined = getCookie("travelerCompanions")
            if (!rawCompany) throw new Error("company is a mandatory cookie for CSE")
            if (!rawCompanyData && (rawCompany === 'cgos' || rawCompany === 'cgosaura' || rawCompany === 'CGOSPM')) throw new Error("companyData is a mandatory cookie for CSE")
            if (!rawTravellerCompanions) throw new Error("travelerCompanions is a mandatory cookie for CSE")
            this.cseData = buildCSEData(rawCompany, JSON.parse(rawCompanyData || "{}"), JSON.parse(rawTravellerCompanions))
            this._initialized = true
        } catch (err) {
            console.error(err)
        }
    }
}